module.exports = __webpack_public_path__ + "img/product_102.4b1af5a.webp";